import { Component, OnInit, Injector } from '@angular/core';
import { ExactService } from './exact.service';
import { colors, AuthorizationSchemeService, AuthorizationScheme, AutocompleteDataSourceFn, MgAutocompleteData, DialogsService } from '@mango/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from '@mango/authentication';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Factuur } from 'src/app/core/dto/factuur';
import { FactuurService } from 'src/app/core/service/factuur.service';
import { TabService } from 'src/app/core/service/tab.service';


export interface ExactFormData {
	factuur: Factuur
}

@Component({
    selector: 'exact',
    templateUrl: './exact.component.html',
    styleUrls: ['./exact.component.css']
})
export class ExactComponent implements OnInit {
    form: FormGroup;
    myScheme: AuthorizationScheme;
    currentUserId: number;

    constructor(
        private auth: AuthenticationService,
        private service: ExactService,
        private factuurService: FactuurService,
        private authService: AuthorizationSchemeService,
        private injector: Injector,
        private snackBar: MatSnackBar,
        private fb: FormBuilder,
        private dialogs: DialogsService,
        private tabService: TabService,
        private router:Router
        )
    {
        this.myScheme = this.authService.getMyScheme();
    }

    ngOnInit(): void {
        this.currentUserId = +this.auth.currentUser.id;

        if (this.myScheme) {
            // nothing yet
        }

    }

    Authenticate() {
        let query: string = environment.exactUrl;

        this.openTab(query);
    }

    async ExporteerFactuur() {

        //var data: ExactFormData = {
        //    factuur: this.form.controls.factuur.value
        //};

        //if (data != null && data.factuur != null && data.factuur?.id > 0)
        //{
            var ok = await this.dialogs.confirm("Exporteer Factuur", `Weer u zeker dat u deze factuur wilt exporteren ?`);

            if(ok)
            {
                await this.service.exporteerFactuur(0).toPromise().then(async value => {
                    if (value.successful) {
                        this.snackBar.open('Exporteren voltooid!', 'ok');
                    }
                    else {
                        if (value.number > 0) {
                            this.snackBar.open('Exporteren voltooid!', 'ok', { duration: 3000 });
                        } else {
                            this.snackBar.open(value.message, 'ok', { duration: 3000 });
                        }
                    }
                    this.refreshPage(value.exportNumber);

                }).catch((e) => {
                    console.log(e);
                    this.snackBar.open(`Exporteren mislukt!`, 'ok', { duration: 3000 });
                });
            }
        //}
        //else
        //{
        //    this.snackBar.open(`U heeft nog geen factuur geselecteerd!`, 'ok', { duration: 3000 });
        //}

    }

    openTab(url: string) {
        this.tabService.openTab(url, '_blank');
    }

    closeTab() {
        this.tabService.closeTab();
    }

    canRead(type: string) {
        return this.myScheme.canRead(type);
    }

    canDoExact() {
        return this.myScheme.canDo('CIJBorculo.Logic.ExactRequest')
    }

    refreshPage(run: number) {
        // Refresh/Reload
        if (run>0) {
            this.router.navigate(['/exactErrorLog'],{ queryParams: { 'eq:exportrun': run }});

        } else {
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
            this.router.navigateByUrl('/exact'));
        }
    }

}
